import axios from 'axios';
const countriesNowBaseUrl = process.env.REACT_APP_COUNTRIES_NOW_URL;
const countriesNowApiEndPoint = process.env.REACT_APP_COUNTRIES_NOW_API_ENDPOINT;
const geoNameBaseUrl = process.env.REACT_APP_GEONAME__URL;
const geoNameUserName = process.env.REACT_APP_GEONAME_USERNAME;

const headers = async (isFormData) => {
    const baseHeaders = {
        Accept: 'application/json',
    };

    if (isFormData) {
        return {
            ...baseHeaders,
            'Content-Type': 'multipart/form-data',
        };
    } else {
        return {
            ...baseHeaders,
            'Content-Type': 'application/json',
        };
    }
};

const countriesNowApiCall = async (path, method, body = {}) => {
    const url = `${countriesNowBaseUrl}${countriesNowApiEndPoint}${path}`;
    const isFormData = body instanceof FormData;
    try {
        const config = {
            method,
            url,
            headers: await headers(isFormData),
            data: body,
        };
        const response = await axios(config);
        return response;
    }
    catch (err) {
        return err;
    }
};

const geonamesApiCall = async (path, method, body = {}) => {
    const url = `${geoNameBaseUrl}${path}&username=${geoNameUserName}`;
    const isFormData = body instanceof FormData;
    try {
        const config = {
            method,
            url,
            headers: await headers(isFormData),
            data: body,
        };
        const response = await axios(config);
        return response;
    }
    catch (err) {
        return err;
    }
};

export { countriesNowApiCall, geonamesApiCall };